/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for submitting document + face identity photos in one guarded write.
 */
export interface OralExamSubmitIdentityPhotosRequest {
  documentImageBase64: string;
  documentContentType?: string;
  selfieImageBase64: string;
  selfieContentType?: string;
}
